import { db } from './offlineQueue';

export const draftId = (installerId, jobId, jobStageId) => `${installerId}:${jobId}:${jobStageId}`;
export function attemptKey() {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export const stageRevision = (stage) => `${stage.state}:${stage.decided_at || stage.opened_at || ''}:${stage.attempt_count || 0}`;
export async function loadDraft(installerId, jobId, stage) {
  const d = await db();
  if (localStorage.getItem('installer_pwa_principal') !== installerId) throw new Error('نشست نیروی اجرایی تغییر کرد. دوباره وارد شوید.');
  const id = draftId(installerId, jobId, stage.id);
  const revision = stageRevision(stage);
  const tx = d.transaction(['stage-drafts', 'stage-outbox'], 'readwrite');
  const existing = await tx.objectStore('stage-drafts').get(id);
  if (existing?.revision === revision) { await tx.done; return existing; }
  const draft = { id, installer_id: installerId, jobId, jobStageId: stage.id, revision,
    client_attempt_key: attemptKey(), photos: [], note: '', field_values: {}, field_warning_acknowledgements: [], fixed_defect_ids: [], updated_at: Date.now(),
    clock_offset_ms: Number.isFinite(existing?.clock_offset_ms) ? existing.clock_offset_ms : 0, server_time: existing?.server_time };
  const outbox = tx.objectStore('stage-outbox');
  for (const item of await outbox.getAll()) {
    if (item.installer_id === installerId && item.jobId === jobId && item.jobStageId === stage.id && item.error && item.revision !== revision) {
      await outbox.delete(item.client_attempt_key);
    }
  }
  await tx.objectStore('stage-drafts').put(draft);
  await tx.done;
  return draft;
}
export async function saveDraft(draft) {
  const saved = { ...draft, updated_at: Date.now() };
  const d = await db();
  if (localStorage.getItem('installer_pwa_principal') !== draft.installer_id) throw new Error('نشست نیروی اجرایی تغییر کرد. دوباره وارد شوید.');
  await d.put('stage-drafts', saved);
  return saved;
}
export async function deleteDraft(id) { await (await db()).delete('stage-drafts', id); }
export async function listDrafts(installerId) {
  return (await (await db()).getAll('stage-drafts')).filter((d) => d.installer_id === installerId);
}
